import FormattedMessage from 'I18n/components/FormattedMessage';
import { Image as FoundationsImage } from 'foundations-components/transitional/components/Image';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { ButtonText, MicrosoftSignInDiv, ImageWrapper } from './MicrosoftLoginButton.styles';
// @ts-expect-error not converted to TS
import Image from 'LoginUI/images/imageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MicrosoftLoginButton = ({
  onClick,
  smartLogin,
  disabled,
  tooltipDisabled = true
}) => /*#__PURE__*/_jsx(Tooltip, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "login.smartLogin.disabledButtonHelp"
  }),
  disabled: tooltipDisabled,
  children: /*#__PURE__*/_jsxs(MicrosoftSignInDiv, {
    disabled: disabled,
    onClick: onClick,
    "data-test-id": "microsoft-sign-in",
    children: [/*#__PURE__*/_jsx(ImageWrapper, {
      disabled: disabled,
      children: /*#__PURE__*/_jsx(FoundationsImage, {
        src: Image.microsoftLogo
      })
    }), /*#__PURE__*/_jsx(ButtonText, {
      smartLogin: smartLogin,
      children: smartLogin ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "login.form.microsoft"
      }) : /*#__PURE__*/_jsx(TruncateString, {
        reverse: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.form.microsoft"
        })
      })
    })]
  })
});